import { useEffect, useState } from "react";

import { getAdminSidebars } from "@/services";
import { AdminSidebar } from "@/types";
import { handleError } from "@/utils";

// Shared fetch of the DB-backed admin sidebar rows. `getAdminSidebars` dedupes
// the underlying request across callers, so the sidebar menu and the breadcrumbs
// can each call this without triggering extra round-trips.
export function useAdminSidebars(): AdminSidebar[] {
  const [rows, setRows] = useState<AdminSidebar[]>([]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const data = await getAdminSidebars();
        if (!cancelled) setRows(data);
      } catch (error) {
        handleError(error);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  return rows;
}
